import './header.scss';
import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import SideNav from './sidenav';
import UserMenu from './user-menu';
import Notifications from './notifications';
import { useSelector } from 'react-redux';
import { NotificationType, RootState } from 'types';

function Header({
    isPublic,
    showSideNav,
} : {
    isPublic: boolean,
    showSideNav: boolean,
}) {
    const state = useSelector((state: RootState) => state);
    const [showNav, setShowNav] = useState(false);
    const [sideNavOpen, setSideNavOpen] = useState(false);
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const [notificationsOpen, setNotificationsOpen] = useState(false);
    const [notifications, setNotifications] = useState<NotificationType[]>([]);
    const notificationRef = useRef<any>();
    const userMenuRef = useRef<any>();

    const onShowSidenav = (e: React.MouseEvent) => {
        e.stopPropagation();
        setSideNavOpen(!sideNavOpen);
    }

    if (isPublic) {
        return (
            <header className="public">
                <i className={`fal ${showNav ? 'fa-times' : 'fa-bars'}`} onClick={()=> setShowNav(!showNav)}></i>
                <img src={`${process.env.PUBLIC_URL}/img/logofull.svg`} alt="amaSocial Logo" />
                <nav className={showNav ? 'open' : ''}>
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/services">Services</Link></li>
                        <li><Link to="/blogs">Blogs</Link></li>
                        <li><Link to="/about-us">About Us</Link></li>
                        <li><Link to="/contact-us">Contact Us</Link></li>
                        <li><a href="/docs/HR-01-030_Rev_0_PAIA_Manual_amaSocial.pdf" target="_blank" rel="noreferrer" download>POPIA</a></li>
                        {state.user ? (
                            <li><a href="/dashboard" rel="noreferrer">My Dashboard</a></li>
                        ) : (
                            <li><a href="/loginnew" rel="noreferrer">Login</a></li>
                        )}
                    </ul>
                </nav>
            </header>
        )
    } else {
        return (
            <>
                <header className="private">
                    {showSideNav && <i className={`fal ${sideNavOpen ? 'fa-times' : 'fa-bars'}`} onClick={e => onShowSidenav(e)}></i>}
                    <img src={`${process.env.PUBLIC_URL}/img/logofull.svg`} alt="amaSocial Logo" />
                    <i className="fal fa-user" ref={userMenuRef} onClick={() => setUserMenuOpen(!userMenuOpen)}></i>
                    <div className="notification-icon" ref={notificationRef} onClick={() => setNotificationsOpen(!notificationsOpen)}>
                        {notifications.length > 0 && <span>{notifications.length}</span>}
                        <i className="fal fa-bell"></i>
                    </div>
                </header>
                {showSideNav && <SideNav open={sideNavOpen} setOpen={setSideNavOpen}/>}
                <Notifications 
                    open={notificationsOpen}
                    notifications={notifications} 
                    setOpen={setNotificationsOpen} 
                    setNotifications={setNotifications} 
                    buttonRef={notificationRef}
                />
                <UserMenu 
                    open={userMenuOpen}
                    buttonRef={userMenuRef}
                    setOpen={setUserMenuOpen}
                />
            </>
        )
    }
}

export default Header;